import { Label, TextInput, FieldSet, RadioButton } from "@nokia-csf-uxr/ccfk";
import { FieldSetContent, Legend } from "@nokia-csf-uxr/ccfk/FieldSet";
import { RadioButtonLabelContent } from "@nokia-csf-uxr/ccfk/RadioButton";
import React from "react";
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from "../../../contexts/SingleBandLinkContext";
import {REGEX_DEGREE_COORDS} from "../LinkForm";
import Container from "react-bootstrap/esm/Container";
import Form from "react-bootstrap/esm/Form";
import Col from "react-bootstrap/esm/Col";
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from "../../../contexts/DualBandLinkContext";

/**
 * Coordinate input component
 */
export default class Coordinates extends WLDInputComponent {

    constructor(props: {band: number}) {
        super(props);

        this.state = {
            "longitude": "",
            "latitude": ""
        }
    }

    /**
     * Check if a coordinate is right
     * @param link 
     * @returns 
     */
    checkCoords(link: any) {
        let foundError = false;
        if(this.props.longitude != "") {
            if(isNaN(this.props.longitude) && !REGEX_DEGREE_COORDS.test(this.props.longitude)) {
                if(!this.state.longitude_error) {
                    this.setState({"longitude_error": true})
                    foundError = true;
                }
            } else if(this.state.longitude_error) {
                this.setState({"longitude_error": false})
            }
        }

        if(this.props.latitude != "") {
            if(isNaN(this.props.latitude) && !REGEX_DEGREE_COORDS.test(this.props.latitude)) {
                if(!this.state.latitude_error) {
                    this.setState({"latitude_error": true})
                    foundError = true;
                }
            } else if(this.state.latitude_error) {
                this.setState({"latitude_error": false})
            }
        }

        if(foundError) {
            link.define("coordinate_error", true)
            return;
        } else if(!foundError && link.coordinate_error) {
            link.define("coordinate_error", false)
        }
    }

    render() {
        return (
            <Col xs={6}>
                {this.props.band == 1 ?
                
                    <SingleBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                        <>
                            <>
                                <Form.Label>Longitude (degree minute second)</Form.Label>
                                <TextInput className={this.state?.longitude_error ? "invalid-input" : ""} onChange={(e) => {
                                    this.setState({"longitude": e.target.value});
                                    this.props.onChangeCoords(e, "longitude")}} 
                                    onBlur={() => this.checkCoords(link)}
                                    value={this.props.longitude}
                                />
                            </>

                            <FieldSet>
                                
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    <SingleBandLinkReferenceContext.Consumer>
                                    {(linkRef) => (
                                        <>
                                        { ["W", "E"].map((value: string, index: number) =>
                                            <Form.Check
                                                type="radio"
                                                label={ value }
                                                value={ value }
                                                onBlur={() => this.checkCoords(link)}
                                                className={linkRef?.distanceUnits?.length == (index+1) ? "ms-sm-3" : ""}
                                                checked={this.props?.longitude_direction == value}
                                                onChange={(e) => {this.setState({"longitude_direction": value}); this.props.onChangeCoords(e, "longitude_direction")}}   
                                            />
                                        ) }
                                        </>
                                    )}
                                    </SingleBandLinkReferenceContext.Consumer>  
                                </FieldSetContent>

                            </FieldSet>
                        </>

                        <>
                            <>
                                <Form.Label>Latitude (degree minute second)</Form.Label>
                                <TextInput className={this.state?.latitude_error ? "invalid-input" : ""} onChange={(e) => {
                                    this.setState({"latitude": e.target.value});
                                    this.props.onChangeCoords(e, "latitude")
                                    }}
                                    onBlur={() => this.checkCoords(link)}
                                    value={this.props.latitude}
                                    />
                            </>

                            <FieldSet>
                                
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    <SingleBandLinkReferenceContext.Consumer>
                                    {(linkRef) => (
                                        <>
                                        { ["N", "S"].map((value: string, index: number) =>
                                            <Form.Check
                                                type="radio"
                                                label={ value }
                                                value={ value }
                                                className={linkRef?.distanceUnits?.length == (index+1) ? "ms-sm-3" : ""}
                                                checked={this.props?.latitude_direction == value}
                                                onBlur={() => this.checkCoords(link)}
                                                onChange={(e) => {this.setState({"latitude_direction": value}); this.props.onChangeCoords(e, "latitude_direction")}}
                                                />
                                        ) }
                                        </>
                                    )}
                                    </SingleBandLinkReferenceContext.Consumer>  
                                </FieldSetContent>

                            </FieldSet>
                        </>
                    </>
                    )}
                    </SingleBandLinkUserContext.Consumer>
                :
                    <DualBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                        <>
                            <>
                                <Form.Label>Longitude (degree minute second)</Form.Label>
                                <TextInput className={this.state?.longitude_error ? "invalid-input" : ""} onChange={(e) => {
                                    this.setState({"longitude": e.target.value});
                                    this.props.onChangeCoords(e, "longitude")}} 
                                    onBlur={() => this.checkCoords(link)}
                                    value={this.props.longitude}
                                />
                            </>

                            <FieldSet>
                                
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    <DualBandLinkReferenceContext.Consumer>
                                    {(linkRef) => (
                                        <>
                                        { ["W", "E"].map((value: string, index: number) =>
                                            <Form.Check
                                                type="radio"
                                                label={ value }
                                                value={ value }
                                                onBlur={() => this.checkCoords(link)}
                                                className={linkRef?.distanceUnits?.length == (index+1) ? "ms-sm-3" : ""}
                                                checked={this.props?.longitude_direction == value}
                                                onChange={(e) => {this.setState({"longitude_direction": value}); this.props.onChangeCoords(e, "longitude_direction")}}   
                                            />
                                        ) }
                                        </>
                                    )}
                                    </DualBandLinkReferenceContext.Consumer>  
                                </FieldSetContent>

                            </FieldSet>
                        </>

                        <>
                            <>
                                <Form.Label>Latitude (degree minute second)</Form.Label>
                                <TextInput className={this.state?.latitude_error ? "invalid-input" : ""} onChange={(e) => {
                                    this.setState({"latitude": e.target.value});
                                    this.props.onChangeCoords(e, "latitude")
                                    }}
                                    onBlur={() => this.checkCoords(link)}
                                    value={this.props.latitude}
                                    />
                            </>

                            <FieldSet>
                                
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    <DualBandLinkReferenceContext.Consumer>
                                    {(linkRef) => (
                                        <>
                                        { ["N", "S"].map((value: string, index: number) =>
                                            <Form.Check
                                                type="radio"
                                                label={ value }
                                                value={ value }
                                                className={linkRef?.distanceUnits?.length == (index+1) ? "ms-sm-3" : ""}
                                                checked={this.props?.latitude_direction == value}
                                                onBlur={() => this.checkCoords(link)}
                                                onChange={(e) => {this.setState({"latitude_direction": value}); this.props.onChangeCoords(e, "latitude_direction")}}
                                                />
                                        ) }
                                        </>
                                    )}
                                    </DualBandLinkReferenceContext.Consumer>  
                                </FieldSetContent>

                            </FieldSet>
                        </>
                    </>
                    )}
                </DualBandLinkUserContext.Consumer>
                }
            </Col>);
    }
}